import { Tweet } from "../../model/Tweet";
import { checkIsDefined } from "@/shared/Preconditions";
import { TweetAuthor } from "@/domain/model/TweetAuthor";
import { getValue } from "@/shared/RxUtil";
const AUTH_REQUIRED = "Authentication is required to post a tweet";
export class PostTweetUseCaseImpl {
    constructor(tweetRepository, getUser) {
        this.tweetRepository = tweetRepository;
        this.getUser = getUser;
    }
    async run(text) {
        const currentUser = checkIsDefined(await getValue(this.getUser.run()), AUTH_REQUIRED);
        const tweet = new Tweet("", text, TweetAuthor.from(currentUser), new Date(), []);
        this.tweetRepository.addTweet(tweet);
    }
}
